export default __webpack_public_path__ + "static/media/groundplan_d_84c.5e0a1d64.png";